export default __webpack_public_path__ + "static/media/vimeo.159f5443.svg";